import { Plus, X } from 'react-bootstrap-icons';

import { SDSButton } from '@repo/sds/SDSButton';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSIconButton } from '@repo/sds/SDSIconButton';
import { SDSText } from '@repo/sds/SDSText';
import { TimeSelector } from '@repo/ui/components/elements/TimeSelector/TimeSelector';

import { createTimeRange, type TimeRange } from './time-range';

interface TimeRangeEditorProps {
  ranges: TimeRange[];
  onChange: (ranges: TimeRange[]) => void;
}

export function TimeRangeEditor({ ranges, onChange }: TimeRangeEditorProps) {
  const addRange = () => onChange([...ranges, createTimeRange()]);
  const removeRange = (index: number) => {
    onChange(ranges.filter((_, i) => i !== index));
  };

  const updateRange = (index: number, field: 'start' | 'end', value: string) => {
    const updated = ranges.map((r, i) => (i === index ? { ...r, [field]: value } : r));
    onChange(updated);
  };

  return (
    <SDSFlexbox direction="column" gap="text-small">
      {ranges.map((range, i) => (
        <SDSFlexbox key={range.id} direction="row" gap="text-small" alignItems="center">
          <TimeSelector value={range.start} onTimeChange={value => updateRange(i, 'start', value)} />
          <SDSText type="body-medium" text="to" color="inactive" />
          <TimeSelector value={range.end} onTimeChange={value => updateRange(i, 'end', value)} />
          <SDSIconButton icon={<X />} onClick={() => removeRange(i)} ariaLabel="Remove time range" />
        </SDSFlexbox>
      ))}
      <SDSButton mode="outline" size="small" leftIcon={<Plus />} text="Add time slot" onClick={addRange} />
    </SDSFlexbox>
  );
}
